import { useCallback, useEffect } from 'react';
import useViewport from '../hooks/useViewport';
import { trackEvent, trackLink, trackPage } from './ninja-utils';

const usePlatformType = () => {
  const { desktop } = useViewport();
  return desktop ? 'desktop' : 'mobile-html5';
};

export const useTrackPage = (pageName, extraData = {}, condition = true, dependencies = []) => {
  const platformType = usePlatformType();

  useEffect(() => {
    if (condition) {
      trackPage(pageName, platformType, extraData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platformType, pageName, condition, ...dependencies]);
};

export const useTrackEvent = () => {
  const platformType = usePlatformType();

  return useCallback(
    (name, type, data, extras = {}) => trackEvent(name, type, data, platformType, extras),
    [platformType],
  );
};

export const useTrackLink = () => {
  const platformType = usePlatformType();

  return useCallback(
    (linkName, linkCallback, extras, fallbackTimeout) => {
      let callbackCalled = false;
      const callOnce = () => {
        if (callbackCalled) {
          return;
        }

        linkCallback();
        callbackCalled = true;
      };

      if (linkCallback && fallbackTimeout !== undefined) {
        setTimeout(callOnce, fallbackTimeout);
      }

      return trackLink(linkName, callOnce, platformType, extras);
    },
    [platformType],
  );
};
